import { useState } from "react";
import { useFetch, fmtDate } from "@/lib/shieldx";
import { PageHeader, Loader } from "@/components/shieldx/Primitives";
import { DemoTag } from "@/components/shieldx/Badges";
import { Table } from "@/components/shieldx/Table";
import { FileClock, ShieldCheck } from "lucide-react";

export default function AuditLogs() {
  const { data, loading } = useFetch("/audit-logs");
  const [q, setQ] = useState("");
  if (loading || !data) return <Loader label="Loading audit ledger" />;
  const rows = q ? data.filter((l) => JSON.stringify(l).toLowerCase().includes(q.toLowerCase())) : data;

  const columns = [
    { key: "timestamp", label: "Timestamp", render: (r) => <span className="font-mono text-xs text-slate-400">{fmtDate(r.timestamp)}</span> },
    { key: "actor", label: "Actor", render: (r) => <span className="font-mono text-xs text-slate-300">{r.actor}</span> },
    { key: "action", label: "Action", render: (r) => <span className="rounded border border-slate-700 bg-slate-800/60 px-2 py-0.5 font-mono text-[10px] text-slate-300">{r.action}</span> },
    { key: "target", label: "Target", render: (r) => <span className="text-sm text-slate-300">{r.target}</span> },
    { key: "result", label: "Result", render: (r) => <span className={r.result === "SUCCESS" ? "text-emerald-400" : "text-amber-400"}>{r.result}</span> },
    { key: "correlation_id", label: "Correlation", render: (r) => <span className="font-mono text-[11px] text-slate-500">{r.correlation_id}</span> },
  ];

  return (
    <div>
      <PageHeader icon={FileClock} title="Audit Logs"
        subtitle="Tamper-evident ledger of every security-relevant action. Immutable by design — the AI layer cannot delete these records."
        actions={<DemoTag />} />
      <div className="mb-4 flex items-center gap-3">
        <input value={q} onChange={(e) => setQ(e.target.value)} data-testid="audit-search" placeholder="Filter by actor, action, target, correlation ID…"
          className="h-10 w-full max-w-md rounded-lg border border-slate-800 bg-slate-900/70 px-3 text-sm text-slate-100 outline-none focus:border-blue-500/50" />
        <span className="flex items-center gap-1.5 whitespace-nowrap font-mono text-[11px] text-emerald-400"><ShieldCheck className="h-4 w-4" /> Integrity verified</span>
      </div>
      <Table columns={columns} rows={rows} testid="audit-table" />
    </div>
  );
}
